import { Dialog } from '@cimplico/components';
import { toastNotification } from '../../../components/toast/Toast';
import { useMakeReferencesOriginal } from '../../../queries/use-make-references-original';
import { FileRecordNew } from '../../../types/file-record';

type MakeReferenceOriginalConfirmProps = {
    fileRecords: FileRecordNew[];
    onClose: () => void;
};

function MakeReferenceOriginalConfirm({ fileRecords, onClose }: MakeReferenceOriginalConfirmProps): JSX.Element {
    const makeOriginalQuery = useMakeReferencesOriginal();

    const message =
        fileRecords.length === 1
            ? `Do you want to make ${fileRecords[0].name} an original copy?`
            : `Do you want to make ${fileRecords.length} records original copies?`;

    function duplicate(): void {
        makeOriginalQuery.mutate(
            { ids: fileRecords.map((fr) => fr.id) },
            {
                onSuccess: () => {
                    toastNotification(
                        'success',
                        `Made ${fileRecords.length} ${
                            fileRecords.length === 1 ? 'record an original copy' : 'records into original copies'
                        }.`
                    );
                },
                onError: () => {
                    toastNotification('error', `Unable to make records original.`);
                },
                onSettled: () => {
                    onClose();
                },
            }
        );
    }

    return (
        <Dialog
            primaryAction="Make Original"
            secondaryAction="Cancel"
            title="Make References Original"
            description={message}
            type="info"
            isOpen={true}
            onClose={onClose}
            onSecondaryActionClick={onClose}
            onPrimaryActionClick={duplicate}
            isLoading={makeOriginalQuery.isLoading}
        />
    );
}

export default MakeReferenceOriginalConfirm;
